<template>
 
      <div class="flex flex-column pl-2 pr-2">
        <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
          <h2 class="">IGNOROVANÉ EMAILY</h2>
        <!--
          <router-link to="/ignored_email/0" >
            <PrimevueButton label="Pridať ignorovaný email" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
          </router-link>
        -->
        </div>
        <form @submit.prevent="submitIgnoredEmail">
          <div class="field">
            <label class="mr-2" for="email">Pridať ignorovaný email</label>
            <InputText class="w-6" 
              v-model="this.ignoredEmail.email"
              type="text"
              name="email"
              id="email"
              
            >
            </InputText>
          </div>
        </form>
        <DataTable 
          scrollable :scrollHeight="`${this.vh - 300}px`"
          :value="this.ignoredEmails"
          stripedRows
          row-hover
          v-model:editingRows="editingRows"
          editMode="row" dataKey="id" @row-edit-save="submitIgnoredEmail"
          tableStyle="width: 100%"
          :virtualScrollerOptions="{ itemSize: 35 }"
        >
        <!--   
        tableStyle="min-width: 50rem"
          :totalRecords="pagination.totalRecords"
          :rowsPerPageOptions="[200,100,50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :currentPage="pagination.page"
        -->
          <Column field="id" header="ID" style="min-width: 10%">
          </Column>

          <Column field="email" header="Email" style="min-width: 50%">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" class="w-full"/>
            </template>
          </Column>
          
          <Column :rowEditor="true" style="width: 3%; min-width: 3rem" bodyStyle="text-align:center"></Column>
          
          <Column header="" >
            <template #body="slotProps">
                <PrimevueButton type="button" icon="pi pi-trash" @click="deleteIgnoredEmail(slotProps.data.id)" text severity="danger" size="small"/>
            </template>
          </Column>

        </DataTable>


      </div>



</template>

<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import router from "@/router";
import notie from "notie/dist/notie";
import PrimevueButton from 'primevue/button';
import Column from "primevue/column";

export default {
  name: "IgnoredEmailList",
  components: {
    PrimevueButton,
    Column,
  },
  data() {
    return {
      store,
      vh: 0,
      editingRows: [],
      ignoredEmails: [],
      ignoredEmail: {
        id: 0,
        email: "",
      },
     // pagination: {
     //   page: 1,
     //   rows: 20,
     //   totalRecords: 0, // Total number of records for pagination
     // },
     // loading: true,
    }
  },
  beforeMount() {
    //console.log("calling users")
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);

      if(this.store.user.admin===false){
        router.push("/")
        notie.alert({
          type: 'error',
          text: "Na túto akciu nemáte oprávnenia"
        })
      }

      fetch(this.store.Api_url + "/v1/ignored-email?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //this.$emit('error', responseData.data);
              notie.alert({
                type: 'error',
                text: "Zoznam ignorovaných mailov sa nepodarilo načítať"
              })
            } else {
              //console.log('Users', responseData);
              this.ignoredEmails = responseData.data
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní ignorovaných mailov" + error);
            notie.alert({
                type: 'error',
                text: "Chyba pri načítaní ignorovaných mailov"
              })
          })
    }
  },

  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {

    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

    deleteIgnoredEmail(ignoredEmailId:number){
      if(confirm("Naozaj chcete ODSTRÁNIŤ ignorovaný email?")){
        Security.requireToken();

        fetch(store.Api_url + "/v1/ignored-email/"+String(ignoredEmailId)+"?query=deleted:0" , Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'error',
                  text: "Nepodarilo sa odstrániť ignorovaný email"
                })
              } else {
                //// Make a copy of the orders array to avoid mutating during iteration
                //const updatedOrders = [...this.orders];

                //// Find and remove the order with the matching ID
                //const indexToRemove = updatedOrders.findIndex(order => order.id === orderId);
                //if (indexToRemove !== -1) {
                //  updatedOrders.splice(indexToRemove, 1);
                //}

                // Update the UI with the modified orders array
                this.ignoredEmails = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Ignorovaný email bol odstránený",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              //alert('chyba pri nacitani objednavok: ' + error)
              notie.alert({
                  type: 'error',
                  text: "Nastala chyba pri odstránení ignorovaného emailu: "+error
                })             
            })
      }
    },
    submitIgnoredEmail(event){
      //console.log("Event:", event);
      //  Security.requireToken();

      let method = "POST"
      let url = "/v1/ignored-email"  
      //?userId="+this.store.user.id
      if (event.newData){
        //let { newData, index } = event;
        //this.ignoredEmails[index] = newData;
        this.ignoredEmail = event.newData
        method = "PUT"
        url = "/v1/ignored-email/" + this.ignoredEmail.id 
        // + "?userId="+this.store.user.id
      }

      //if(this.ignoredEmail.id > 0){
        fetch(store.Api_url + url+"?query=deleted:0", Security.requestOptions(method,this.ignoredEmail))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'error',
                  text: "Nepodarilo sa uložiť ignorovaný email"
                })
              } else {
                //// Make a copy of the orders array to avoid mutating during iteration
                //const updatedOrders = [...this.orders];

                //// Find and remove the order with the matching ID
                //const indexToRemove = updatedOrders.findIndex(order => order.id === orderId);
                //if (indexToRemove !== -1) {
                //  updatedOrders.splice(indexToRemove, 1);
                //}
                //console.log("ignoreEmails: ", responseData.data);
                // Update the UI with the modified orders array
                this.ignoredEmails = responseData.data;
                this.ignoredEmail = {
                  id: 0,
                  email: "",
                },
                notie.alert({
                  type: 'success',
                  text: "Ignorovaný email bol uložený",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              //alert('chyba pri nacitani objednavok: ' + error)
              notie.alert({
                  type: 'error',
                  text: "Nastala chyba pri uložení ignorovaného emailu: "+error
                })             
            })
      //}
    },
  }  
  
}
</script>



<style scoped>

</style>